module.exports = __webpack_public_path__ + "img/pmg3.7637b966.png";